/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

const defaultDiscoveryUri = 'https://pcast.phenixrts.com/pcast/endPoints';

export {defaultDiscoveryUri};